<template>
  <div
    ref="emdDropdown"
    class="emd-dropdown"
    v-click-outside="closeDropdown"
    v-on="$listeners"
    :class="{
      '_balloon' : balloon,
      '_position_right' : position && position === 'right'
    }"
  >
    <div
      class="emd-dropdown__trigger"
      :class="{ _active: isActive }"
      @click="toggleDropdown"
      data-testid="dropdown-trigger"
    >
      <slot name="trigger"></slot>
    </div>
    <div
      ref="emdDropdownContent"
      class="emd-dropdown__content"
      :class="{ _active: isActive }"
      @click="closeDropdown"
      data-testid="dropdown-content"
    >
      <slot name="content"></slot>
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EmdDropDown',
  props: {
    active: Boolean,
    position: {
      type: String,
      required: false,
      default: null
    },
    balloon: {
      type: Boolean,
      required: false,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isActive: false
    }
  },

  watch: {
    active (value) {
      this.isActive = value
    }
  },

  methods: {
    toggleDropdown () {
      this.isActive = !this.isActive
      this.$emit('toggle', this.isActive)

      if (!this.isActive) {
        return
      }

      if (!this.fixed) return

      this.$nextTick(() => {
        const dropdownElement = this.$refs.emdDropdownContent
        const containerWidth = dropdownElement.parentElement.offsetWidth
        const dropdownWidth = dropdownElement.offsetWidth
        const dropdownRightPos = dropdownElement.offsetLeft + dropdownWidth
        if (dropdownRightPos > containerWidth) {
          dropdownElement.style.right = '0'
          dropdownElement.style.left = 'auto'
        }
      })
    },
    closeDropdown () {
      this.isActive = false
      this.$emit('close', this.isActive)
    }
  }
}
</script>

<style scoped>
.emd-dropdown__content {
  transition: none;
}
</style>
